export const BLANK_PAGE_ROUTE = '/eduphoria_webcontrols/gray.htm';
export const EVALUATION_PROCESS_INSTANCE_ROUTE = '/appraiseevalapi/instance/user';
export const EVALUATIONS_ROUTE = '/appraiseapi2/evaluations';
export const MANAGE_TESTS_ROUTE = '/aware/Manage/Tests';
export const MULTI_TEST_ANALYSIS_ROUTE = '/awareapi2/Analyze/MultiTest';
export const ONLINE_TESTING_BASE_ROUTE = '/aware/onlinetesting';
export const ONLINE_TESTING_ROUTE = '/onlineTestingApi/onlineTesting';
export const ONLINE_TESTING_API2_ROUTE = '/onlinetestingapi2';
export const PRINT_TEST_ROUTE = '/aware/manage/tests/api/testprinter.aspx';
export const PUBLIC_ITEM_BANK = '/publicItemBank';
export const REPORTING_ROUTE = '/awareapi2/reporting';
export const SIGNATURES_POPUP_ROUTE =
  '/eduphoria_webcontrols/signatures/signaturepopup.aspx';
export const STUDENT_TESTING_PORTAL_ROUTE = '/student';
export const TEMPLATES_ROUTE = '/appraiseapi2/templates';
export const TEST_AUTHORING_BASE_ROUTE = '/assessments/author';
export const TEST_AUTHORING_ROUTE = '/assessments/author/edit';
export const TEXT_TO_SPEECH_ROUTE = '/onlinetestingapi/TextToSpeech';
export const TEST_ENTRY_ROUTE = '/onlinetestingapi/TestEntries';
export const TEST_PROCTORING_ROUTE = '/testproctoringapi/testsavailable/proctoring';
export const TEST_ROUTE = '/awareapi2/Tests';
export const V2_ANALYZE_ASSESSMENTS_ROUTE = '/awareapi2/analyze/tests';
export const V2_AUTHOR_ASSESSMENTS_ROUTE = '/awareapi2/testadministrationsearch';
export const V2_STUDENT_PROFILES_ROUTE = '/awareapi2/student-search';
export const V2_STUDENT_PROFILES_FILTER_OPTIONS_ROUTE = '/awareapi2/student-search/options';
